import { BACKEND_URL, API } from './api';

// Token stored in localStorage - works everywhere
export const getToken = () => localStorage.getItem('session_token');
export const setToken = (token) => token ? localStorage.setItem('session_token', token) : localStorage.removeItem('session_token');
export const clearToken = () => localStorage.removeItem('session_token');

// Authenticated fetch wrapper - uses localStorage token + cookie fallback
export const authFetch = (url, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return fetch(url, { ...options, headers, credentials: 'include' });
};
